export default "__VITE_ASSET__DxZEY4Qn__"